import { ObjectRegistry } from '@lts-web/registry';
import { LocationList } from '@lts-web/list-objects';

export const DESTINATION_ALL = 'ALL';
export const HOTEL_ALL = 'ALL';
export const ORIGIN_ALL = 'FROM_ALL';

class LocationUtil {
    static DESTINATION_ALL = DESTINATION_ALL;
    static HOTEL_ALL = HOTEL_ALL;
    static ORIGIN_ALL = ORIGIN_ALL;
    static #registry = new ObjectRegistry(LocationList);

    /**
     * Get the name of origin location
     * @return {string}
     */
    static getOriginName () {
        return LocationUtil.getLocation('domesticPackage', 'cityCode', 'TLV').getCityName();
    }

    /**
     * Get a LocationList object by type
     * @param type
     * @returns {LocationList|null}
     */
    static getLocationList (type) {
        return LocationUtil.#registry.get(type);
    }

    /**
     * Create LocationList object
     * @param type
     * @param locations
     * @returns {boolean}
     */
    static createLocationList (type, locations = []) {
        return LocationUtil.#registry.set(type, new LocationList(type, locations));
    }

    /**
     * Check if location list is empty
     * @param type
     * @return {boolean}
     */
    static isLocationListEmpty (type) {
        return LocationUtil.getLocationList(type).isEmpty();
    }

    /**
     * Add LocationData object to an existent LocationList by type
     * @param type
     * @param locationData
     * @returns {Number}
     */
    static addLocation (type, locationData) {
        const locationList = LocationUtil.getLocationList(type);

        if (!locationList)
            return -1;

        return locationList.add(locationData);
    }

    /**
     * Get LocationData object by property (using the Array.prototype.find method)
     * @param type
     * @param property
     * @param value
     * @returns {LocationData|null}
     */
    static getLocation (type, property, value) {
        const locationList = LocationUtil.getLocationList(type);

        if (!locationList)
            return null;

        return locationList.getByProperty(property, value) || null;
    }

    /**
     * Filter a LocationList object by property (using the Array.prototype.filter method)
     * @param type
     * @param property
     * @param value
     * @returns {Array|null}
     */
    static getLocationsByProperty (type, property, value) {
        const locationList = LocationUtil.getLocationList(type);

        if (!locationList)
            return null;

        return locationList.filterByProperty(property, value) || null;
    }

    /**
     * Find the first suggested LocationData object (using the Array.prototype.find method)
     * @param type
     * @param property
     * @param value
     * @returns {LocationData|null}
     */
    static findLocationByProperty (type, property, value) {
        const locationList = LocationUtil.getLocationList(type);

        if (!locationList)
            return null;

        return locationList.findByProperty(property, value) || null;
    }

    /**
     * Filter a LocationList by suggested value's property (using the Array.prototype.filter method)
     * @param type
     * @param property
     * @param value
     * @returns {Array|null}
     */
    static suggestLocationsByProperty (type, property, value) {
        const locationList = LocationUtil.getLocationList(type);

        if (!locationList)
            return null;

        return locationList.suggestByProperty(property, value) || null;
    }

    /**
     * Get a LocationData object by either cityCode or cityName properties
     * @param type
     * @param value
     * @returns {LocationData|null}
     */
    static getLocationByCity (type, value) {
        const locationList = LocationUtil.getLocationList(type);

        if (!locationList)
            return null;

        return locationList.get(value) || null;
    }

    /**
     * Get a LocationData cityCode property by either cityCode or cityName properties
     * @param type
     * @param value
     * @returns {*|null}
     */
    static getLocationCityCode (type, value) {
        const locationData = LocationUtil.getLocationByCity(type, value);
        return locationData !== null ? locationData.getCityCode() : null;
    }

    /**
     * Check if location city value is valid
     * @param type
     * @param cityValue
     * @returns {*}
     */
    static isLocationValid (type, cityValue) {
        const locationList = LocationUtil.getLocationList(type);

        if (!locationList)
            return false;

        return (
            locationList.getByCityCode(cityValue) ||
            locationList.getByCityName(cityValue)
        );
    }

    /**
     * Check if location system type is equal to the provided systemType argument.
     * @param type {string}
     * @param cityValue {string}
     * @param systemType {symbol}
     * @return {boolean}
     */
    static includesSystemType (type, cityValue, systemType) {
        let cityArr = cityValue.split(',');
        let hasSystemType = cityArr.some((destination) => {
            let locationData = LocationUtil.getLocationByCity(type, destination);

            if (!locationData)
                return false;

            return locationData.getSystemTypes().includes(systemType);
        });

        /*const locationData = LocationUtil.getLocationByCity(type, cityValue);

        if (!locationData)
            return false;

        return locationData.getSystemTypes().includes(systemType);*/

        return hasSystemType;
    }

    /**
     * Get a LocationList.sort fn
     * @param key
     * @returns {Function}
     */
    static getSortFn (key) {
        return LocationList.sorts[key];
    }
}

export default LocationUtil;